<template>
  <div id="productos-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10 xs12 md12>
        <v-card>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text">{{
              titleViewCenter
            }}</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <v-form ref="form" v-model="validacion" lazy-validation>
              <v-layout>
                <v-flex>
                  Código: {{ codigo }}
                  <v-textarea
                    v-model="descripcion"
                    :error-messages="descripcionErrors"
                    label="Descripción de tipo de producto"
                    counter="300"
                    maxlength="300"
                    :box="tipeView == 'consulta'"
                    :readonly="tipeView == 'consulta'"
                    @input="$v.descripcion.$touch()"
                    @blur="tipeView == 'crear' ? $v.descripcion.$touch() : null"
                  ></v-textarea>

                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fechaVencimiento"
                        label="Fecha de vencimiento"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fechaVencimiento"
                      @input="menu1 = false"
                      no-title
                      locale="es"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <!-- Campo de Fecha de Vencimiento con el nuevo DatePicker -->
                <v-flex xs12 md6>
                  
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              v-if="tipeView == 'crear' || tipeView == 'modificar'"
              :loading="loading"
              color="primary"
              @click="save()"
              >Guardar <v-icon right dark>save</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import axios from "axios";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "tipo-producto-registra-imp",
  components: {
    Loading,
  },
  props: {},

  data() {
    return {
      loading: false,
      validacion: false,
      tipeView: "",
      titleViewCenter: "",
      idContrato: 0,
      idProducto: 0,
      idPestana: 0,
      codigo: "",
      descripcion: "",
      fechaVencimiento: "", 
    };
  },
  mixins: [validationMixin],
  validations: {
    descripcion: { required },
    fechaVencimiento: { required },
  },

  computed: {
    descripcionErrors() {
      const errors = [];
      if (!this.$v.descripcion.$dirty) return errors;
      !this.$v.descripcion.required &&
        errors.push("Descripcion es obligatorio.");
      return errors;
    },
  },
  mounted() {},
  created() {
    this.tipeView = this.$route.params.tipeView;
    this.titleViewCenter = this.$route.params.titleViewCenter;
    this.idContrato = this.$route.params.idContrato;
    this.idProducto = this.$route.params.idProducto;
    this.codigo = this.$route.params.codigo;
    this.descripcion = this.$route.params.descripcion;
    this.idPestana = this.$route.params.idPestana;
    let f  = this.$route.params.fechaVencimiento || "";
    this.fechaVencimiento = this.formatDateToISO(f) || "";
  },

  methods: {
    save() {
      this.loading = true;
      this.guarda();
      this.loading = false;
    },

    guarda() {
      if (
        this.codigo == undefined ||
        this.codigo == null ||
        this.codigo == "" ||
        this.descripcion == undefined ||
        this.descripcion == null ||
        this.descripcion == "" || !this.fechaVencimiento
      ) {
        window.getApp.$emit("DATOS_INCOMPLETOS");
        return;
      }
      console.log(this.fechaVencimiento);
      this.body = {
        idContrato: this.idContrato,
        id: this.idProducto,
        tipoProducto: this.idPestana,
        codigo: this.codigo,
        descripcion: this.descripcion,
        fechaVencimiento: this.formatoFecha(this.fechaVencimiento), 
        idUserLogged: this.$store.getters.userLogged.id,
        subProceso: this.$store.getters.subProTabSelectedStored,
      };

      axios
        .post("/guardaSuperProdReport", this.body)
        .then((response) => {
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },
    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    formatDateToISO(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    volver() {
      if (this.descripcion != null && this.descripcion != "") {
        this.$store.commit("sub_tab_state", this.descripcion);
      }

      this.$router.go(-1);
    },
  },
};
</script>
